/* eslint-env browser */
export default WebSocket;
//# sourceMappingURL=web-socket.browser.js.map